// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:lang(ar) .react-tel-input .selected-flag {
  padding: 0;
  padding-inline-start: 8px !important;
}
html:lang(ar) .react-tel-input .selected-flag .arrow {
  left: auto !important;
  right: 20px !important;
}
html:lang(ar) .react-tel-input .form-control {
  text-align: end;
  padding-inline-end: 48px;
}

.ReactModal__Overlay {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 500ms ease-in-out;
}

.ReactModal__Overlay--after-open {
  opacity: 1;
  transform: translateX(0px);
}

.ReactModal__Overlay--before-close {
  opacity: 0;
  transform: translateX(-100px);
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,oCAAA;AAAJ;AAEE;EACE,qBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,eAAA;EACA,wBAAA;AAAJ;;AAGA;EACE,UAAA;EACA,6BAAA;EACA,iCAAA;AAAF;;AAGA;EACE,UAAA;EACA,0BAAA;AAAF;;AAGA;EACE,UAAA;EACA,6BAAA;AAAF","sourcesContent":["html:lang(ar) {\n  .react-tel-input .selected-flag {\n    padding: 0;\n    padding-inline-start: 8px !important;\n  }\n  .react-tel-input .selected-flag .arrow {\n    left: auto !important;\n    right: 20px !important;\n  }\n  .react-tel-input .form-control {\n    text-align: end;\n    padding-inline-end: 48px;\n  }\n}\n.ReactModal__Overlay {\n  opacity: 0;\n  transform: translateX(-100px);\n  transition: all 500ms ease-in-out;\n}\n\n.ReactModal__Overlay--after-open {\n  opacity: 1;\n  transform: translateX(0px);\n}\n\n.ReactModal__Overlay--before-close {\n  opacity: 0;\n  transform: translateX(-100px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
